import React from 'react';
import { useField } from '@formiz/core';
import { Input } from '@chakra-ui/react';

export const DateField = (props) => {
	const validations =
		props.validations ||
		(props.required
			? [{ rule: (value) => !!value, message: props.required }]
			: []);

	const { errorMessage, id, isValid, isSubmitted, setValue, value } = useField(
		props,
		validations
	);

	const showError = !isValid && isSubmitted;

	const formatToUK = (date) => {
		if (!date) return '';
		return new Intl.DateTimeFormat('en-GB').format(new Date(date));
	};

	const handleChange = (e) => {
		const inputDate = e.target.value;
		const parsedDate = new Date(inputDate);

		if (!isNaN(parsedDate)) {
			const isoDate = parsedDate.toISOString();
			setValue(isoDate);
		} else {
			console.error('Invalid date format');
		}
	};

	return (
		<div
			className={`field-container ${
				!isValid && isSubmitted ? 'is-error' : ''
			}`}>
			<label htmlFor={id}>
				{props.label} {props.required && '*'}
			</label>
			<br></br>
			<Input
				type='date'
				id={id}
				value={value ? new Date(value).toISOString().split('T')[0] : ''}
				onChange={handleChange}
				size='md'
				placeholder='dd/mm/yyyy'
				style={{
					width: '100%',
					border: '1.5px solid #ddd',
					fontSize: '1rem',
					height: '35px',
					borderRadius: '4px',
				}}
			/>
			<div className='uk-date-display'>{value && formatToUK(value)}</div>
			{showError && (
				<div
					id={`${id}-error`}
					className='error-feedback'>
					{errorMessage}
				</div>
			)}
		</div>
	);
};
